import { SectionHeading } from '@/features/approving_invoice_reports/components/PaymentDetailDrawer/components/SectionHeading';
import { useApprovalDrawerViewOptimizationFlag } from '@/hooks/feature_flag/useApprovalDrawerViewOptimizationFlag';
import { useTranslation } from '@/i18n';
import { FC, memo } from 'react';
import { JournalInfoLayoutSwitch } from './LayoutSwitch';
import { JournalInfoTableView } from './Table';

type JournalInfoProps = { reportId: string };

export const JournalInfo: FC<JournalInfoProps> = memo(({ reportId }) => {
  const { t } = useTranslation();
  const isLayoutSwitchEnabled = useApprovalDrawerViewOptimizationFlag();

  return (
    <SectionHeading title={t('journal_entry.section_title')}>
      {isLayoutSwitchEnabled ? (
        <JournalInfoLayoutSwitch reportId={reportId} />
      ) : (
        <JournalInfoTableView reportId={reportId} />
      )}
    </SectionHeading>
  );
});
JournalInfo.displayName = 'JournalInfo';
